import { Select,Form, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { useBnsJiaoChengListQuery, useGwGoodsListQuery } from '../../store/ReactWebSiteApi';

function TeachSelect(props) {
    const [list,setList] = useState();
    const [goodsId,setGoodsId] = useState('');
    const [listGoods,setListGoods] = useState([]);
    const {data,isSuccess} =useBnsJiaoChengListQuery({bjc_e_id:localStorage.getItem('e_id'),bjc_eowg_id:goodsId},{refetchOnMountOrArgChange:1,skip:!goodsId})
     const {data:dataGoods,isSuccess:isSuccessGoods} = useGwGoodsListQuery({
        eowg_e_id:localStorage.getItem('e_id'),
        eowg_sub_type_id:'',
        eowg_type_id:'',
    },{refetchOnMountOrArgChange:1})  
    useEffect(() => {
        if(isSuccessGoods && dataGoods.Status==='success'){
            const newArr = dataGoods.Result.map((item) => {
                const {eowg_id,eowg_name }=item;
                return item = {value:eowg_id,label:eowg_name }
            })
            setListGoods(newArr)
        }


        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {bjc_id,bjc_name }=item;
                    return item = {value:bjc_id,label:bjc_name }
                })
                setList(newArr)
            }
        }
    },[data, dataGoods, isSuccess, isSuccessGoods])
    return (
        <>
            {props.direction==='vertical' ?<>
                <Form.Item 
                    name={props.nameGoods}
                    label='商品'
                    required
                    wrapperCol={props.wrapperCol}
                >
                    <Select 
                        options={listGoods} 
                        onChange={(e,f) => {
                            setGoodsId(e)
                        }}
                        style={props.styleGoods}
                    />
                </Form.Item>
                <Form.Item 
                    name={props.name}
                    label='模块'
                    required
                    wrapperCol={props.wrapperCol}
                >
                    <Select 
                        options={list} 
                        onChange={(e,f) => {
                            props.onChange(e,f.label,)
                        }}
                        defaultValue={props.defaultId}
                        placeholder={props.defaultId}
                        style={props.style}
                    />
                </Form.Item>
            </>:<>
                <Space>
                    <Form.Item 
                        name={props.nameGoods}
                        label='商品'
                    >
                        <Select 
                            options={listGoods} 
                            onChange={(e,f) => {
                                setGoodsId(e)
                            }}
                            style={props.styleGoods}
                        />
                    </Form.Item>
                    <Form.Item 
                        name={props.name}
                        label='模块'
                    >
                        <Select 
                            options={list} 
                            onChange={(e,f) => {
                                props.onChange(e,f.label,)
                            }}
                            defaultValue={props.defaultId}
                            placeholder={props.defaultId}
                            style={props.style}
                        />
                    </Form.Item>
                </Space>
            </>}
        </>
    )
}

export default TeachSelect